"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const schema_1 = __importStar(require("./schema"));
const schemaComponents_1 = require("@/schemaComponents");
const models_hook_1 = require("app/models.hook");
const auth_1 = require("common/auth");
const url_1 = require("utils/url");
const index_1 = require("../../../../index");
function AuditLogs({ projectId: _projectId }) {
    (0, auth_1.useAdminPageAuthorization)();
    const { value: searchParamsValue } = (0, url_1.useSearchParamAccessor)();
    const { path, collectionName, projectId: paramsProjectId, } = searchParamsValue || {};
    const projectId = _projectId || paramsProjectId || "";
    const { list, loading, hasMore, refresher, fetching, reload, setRange, get } = (0, models_hook_1.useAuditLogList)({
        condition: collectionName || path
            ? {
                records: {
                    $elemMatch: Object.assign(Object.assign({}, (collectionName ? { collectionName } : {})), (path ? { path } : {})),
                },
            }
            : undefined,
        projectId,
    });
    console.log("list", list);
    const contextText = (0, react_1.useMemo)(() => {
        if (path) {
            return `ドキュメント`;
        }
        else if (collectionName) {
            return `${schema_1.collectionNameMap[collectionName]}`;
        }
        else if (projectId) {
            return `翻訳プロジェクト全体`;
        }
        else {
            return "システム全体";
        }
    }, [path, collectionName, projectId]);
    const parameter = (0, react_1.useMemo)(() => ({
        title: `更新履歴(${contextText})`,
        edit: {
            path: ({ auditLogId }) => {
                if (projectId) {
                    return (0, index_1.resolveRoute)("UPDATE_PROJECT_AUDIT_LOG", { auditLogId, projectId }, { retainSearchParams: true });
                }
                else {
                    return (0, index_1.resolveRoute)("UPDATE_PROJECT_AUDIT_LOG", { auditLogId, projectId }, { retainSearchParams: true });
                }
            },
        },
        download: {
            isDisabled: true,
        },
        schema: schema_1.default,
        setRange,
    }), [schema_1.default, setRange, contextText]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(schemaComponents_1.SchemaListPage, { parameter: parameter, list: list, loading: loading, hasMore: hasMore, fetching: fetching, refresher: refresher, 
            // header={conditionSelector}
            reload: reload })));
}
exports.default = AuditLogs;
